import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Handshake, Sparkles, FileBadge, Plane } from "lucide-react";
import "./ProcessJourney.css";

const STEPS = [
  {
    icon: Handshake,
    title: "Understand Your Needs",
    body: "We listen to what you're hiring for, who you need, and what matters most. Then we move.",
  },
  {
    icon: Sparkles,
    title: "Match and Prepare",
    body: "We find candidates who fit. We make sure they're ready—skills, documents, mindset. Both sides prepared.",
  },
  {
    icon: FileBadge,
    title: "Handle Every Detail",
    body: "Visas. Medical exams. Travel. We manage it all. You and your team focus on what's next.",
  },
  {
    icon: Plane,
    title: "Deploy and Stay Close",
    body: "Day one introduction. Regular check-ins. If something shifts, we catch it early and solve it together.",
  },
];

function Step({ icon: Icon, title, body, index, total }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5, margin: "-10%" });

  return (
    <motion.div
      ref={ref}
      className="journey__step"
      initial={{ opacity: 0, y: 32 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 32 }}
      transition={{
        duration: 0.6,
        delay: index * 0.07,
        ease: [0.22, 1, 0.36, 1],
      }}
    >
      <div className="journey__step-rail" aria-hidden="true">
        <span className={`journey__step-marker ${inView ? "is-active" : ""}`}>
          <Icon size={18} strokeWidth={1.8} />
        </span>
        {index < total - 1 && (
          <span className={`journey__step-line ${inView ? "is-active" : ""}`} />
        )}
      </div>
      <div className="journey__step-body">
        <div className="journey__step-num">
          {String(index + 1).padStart(2, "0")}
        </div>
        <h3 className="journey__step-title">{title}</h3>
        <p className="journey__step-copy">{body}</p>
      </div>
    </motion.div>
  );
}

export default function ProcessJourney() {
  return (
    <section className="journey">
      <div className="container">
        <div className="journey__header">
          <span className="eyebrow">How it works</span>
          <h2 className="journey__title">
            Four Steps From Need to <span className="journey__title-accent">Team.</span>
          </h2>
          <p className="journey__intro">
            A clear path for both employers and workers. Here&rsquo;s what
            partnership looks like.
          </p>
        </div>

        <div className="journey__steps">
          {STEPS.map((s, i) => (
            <Step
              key={s.title}
              icon={s.icon}
              title={s.title}
              body={s.body}
              index={i}
              total={STEPS.length}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
